import { useState } from "react";

import {
    ChevronDown,
    FolderInput,
    FolderPlus,
    Link2,
    Download,
    Trash2,
    Pencil,
    Zap
} from "lucide-react";

import useToast from "../common/toast/useToast";

export default function MediaActionButtons({

    media,

    onRename,

    onMove,

    onAdd,

    onDownload,

    onCopyUrl,

    onDelete

}){

    const toast =
        useToast();

    const [

        open,

        setOpen

    ] = useState(false);

    if(!media){

        return null;

    }

    async function copyUrl(){

        if(onCopyUrl){

            return onCopyUrl(media);

        }

        if(!media.previewUrl){

            toast.error(
                "URL is not available."
            );

            return;

        }

        try{

            await navigator.clipboard.writeText(

                media.previewUrl

            );

            toast.success(

                "URL copied successfully."

            );

        }catch{

            toast.error(

                "Failed to copy URL."

            );

        }

    }

    return(

        <div className="media-actions-card">

            <div

                className="media-section-title"

                onClick={()=>

                    setOpen(

                        previous=>!previous

                    )

                }

            >

                <div className="media-section-left">

                    <ChevronDown

                        size={18}

                        className={

                            open

                            ? "section-chevron open"

                            : "section-chevron"

                        }

                    />

                    <Zap size={18}/>

                    <span>

                        Quick Actions

                    </span>

                </div>

            </div>

            <div

                className={

                    open

                    ? "media-actions-body open"

                    : "media-actions-body"

                }

            >

                <div className="media-actions">

                    {/*

                    <button
                        onClick={()=>
                            onRename?.(media)
                        }
                    >

                        <Pencil size={17}/>

                        Rename

                    </button>

                    */}

                    <button

                        onClick={()=>

                            onMove?.(media)

                        }

                    >

                        <FolderInput size={17}/>

                        Move

                    </button>

                    <button

                        onClick={()=>

                            onAdd?.(media)

                        }

                    >

                        <FolderPlus size={17}/>

                        Add To List

                    </button>

                    <button

                        onClick={copyUrl}

                    >

                        <Link2 size={17}/>

                        Copy URL

                    </button>

                    <button

                        onClick={()=>

                            onDownload?.(media)

                        }

                    >

                        <Download size={17}/>

                        Download

                    </button>

                    <button

                        className="danger"

                        onClick={()=>

                            onDelete?.(media)

                        }

                    >

                        <Trash2 size={17}/>

                        Delete

                    </button>

                </div>

            </div>

<style>{`

.media-actions-card{

    background:#FFF;

    border:1px solid #E5E7EB;

    border-radius:18px;

    padding:20px;

    box-shadow:0 1px 2px rgba(15,23,42,.05);

}

.media-section-title{

    display:flex;

    align-items:center;

    cursor:pointer;

    user-select:none;

}

.media-section-left{

    display:flex;

    align-items:center;

    gap:10px;

    font-size:17px;

    font-weight:700;

    color:#0F172A;

}

.media-section-left svg{

    color:#2563EB;

}

.section-chevron{

    color:#94A3B8 !important;

    transition:transform .2s ease;

    transform:rotate(-90deg);

}

.section-chevron.open{

    transform:rotate(0deg);

}

.media-actions-body{

    overflow:hidden;

    max-height:0;

    opacity:0;

    transition:

        max-height .25s ease,

        opacity .2s ease;

}

.media-actions-body.open{

    max-height:500px;

    opacity:1;

    margin-top:18px;

}

.media-actions{

    display:flex;

    flex-direction:column;

    gap:10px;

}

.media-actions button{

    display:flex;

    align-items:center;

    gap:12px;

    width:100%;

    height:46px;

    border:none;

    border-radius:12px;

    background:#F8FAFC;

    padding:0 16px;

    cursor:pointer;

    font-size:14px;

    font-weight:500;

    color:#334155;

    transition:.18s;

}

.media-actions button svg{

    color:#64748B;

}

.media-actions button:hover{

    background:#EEF4FF;

    transform:translateX(2px);

}

.media-actions button:hover svg{

    color:#2563EB;

}

.media-actions .danger{

    background:#FEF2F2;

    color:#DC2626;

}

.media-actions .danger svg{

    color:#DC2626;

}

.media-actions .danger:hover{

    background:#FEE2E2;

}

`}</style>

        </div>

    );

}